import VueApexCharts from 'vue-apexcharts'
import api from '../../services/service_report'
import Swal from 'sweetalert2'
import moment from 'moment'
import Con from '../../../static/config.json'

export default {
  data () {
    const baseUrl = Con.URL
      .replace(/index\.php\/?$/, '')
      .replace(/\/api\/?$/, '/')
    return {
      dateStart: this.dateFormatDMY2(new Date()),
      dateEnd: this.dateFormatDMY2(new Date()),
      data_receive: '',
      data_list: [],
      group_id: '',
      data_month: '',
      pdf_url: baseUrl + 'pdf/receivebygroup_pdf.php',
      excel_url: baseUrl + 'excel/receivebygroup_excel.php',
      header: {
        headers: {
          'access-token': this.$store.state.token
        }
      }
    }
  },
  components: {
    apexchart: VueApexCharts
  },
  methods: {
    getReport () {
      this.$store.state.isLoading = true
      api.getReceivebygroup(
        {
          'date_start': this.dateStart,
          'date_end': this.dateEnd,
          'group': this.group_id,
          'active_page': 1,
          'per_page': 100000000
        },
        this.header,
        result => {
          if (result.response === true) {
            this.$store.state.isLoading = false
            this.data_receive = JSON.stringify(result.data)
            this.data_list = result.data.pagination
          } else {
            alert(JSON.stringify(result))
            Swal.fire('ดึงข้อมูลหมวดหมู่', result.data, 'warning')
            this.data_receive = ''
            this.data_list = []
            this.$store.state.isLoading = false
          }
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    }
  },
  mounted () {
    this.getReport()
    $('input').on('change', function () {
      this.setAttribute(
        'data-date',
        moment(this.value, 'YYYY-MM-DD')
          .format(this.getAttribute('data-date-format'))
      )
    }).trigger('change')
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/reportincomeusermonth.js